document.addEventListener('DOMContentLoaded', () => {
    const radioGroups = document.querySelectorAll("[role='radiogroup']");

    radioGroups.forEach((radioGroup) => {
        const radioButtons = radioGroup.querySelectorAll("input[type='radio']");

        radioButtons.forEach((radioButton) => {
            initializeRadioButton(radioGroup, radioButton);
        });
    });
});

function initializeRadioButton(radioGroup: Element, radioButton: Element) {
    const inputElement = radioButton as HTMLInputElement;
    inputElement.setAttribute('aria-checked', inputElement.checked.toString());
    inputElement.tabIndex = inputElement.checked ? 0 : -1;

    if (inputElement.checked) radioGroup.setAttribute('aria-activedescendant', inputElement.id);

    inputElement.addEventListener('focus', () => {
        const selectedOptionId = radioGroup.getAttribute('aria-activedescendant');
        if (selectedOptionId) {
            const selectedOption = document.getElementById(
                selectedOptionId,
            ) as HTMLInputElement | null;
            if (selectedOption) {
                selectedOption.setAttribute('aria-checked', 'false');
                selectedOption.tabIndex = -1;
            }
        }

        radioGroup.setAttribute('aria-activedescendant', inputElement.id);

        inputElement.setAttribute('aria-checked', 'true');
        inputElement.tabIndex = 0;
    });
}

export default initializeRadioButton;
